<template>
  <div class="container">
    <VasionInput
      v-model="fieldsData.packageName"
      title="Package Name"
      inputType="top-white"
      required
      :isInErrorState="false"
    />
  </div>
</template>
<script>
export default {
  name: 'PackageTabFields',
  data: function () {
    return {
      fieldsData: {
        packageName: '',
      },
    }
  },
}
</script>
<style lang="scss" scoped></style>
